<div class="banner" [style.height]="height" [ngStyle]="{'background-image': 'url(' + backgroundImage + ')'}" aria-hidden="true"></div>
<!-- Content projection -->
<ng-content></ng-content>